/** App Store Connect subscription product IDs (iOS). */
export const APPLE_IAP_PRO_MONTHLY = 'com.peakperformanceiq.app.pro.monthly';
export const APPLE_IAP_ADFREE_MONTHLY = 'com.peakperformanceiq.app.adfree.monthly';

export const APPLE_IAP_PRODUCT_IDS = [APPLE_IAP_PRO_MONTHLY, APPLE_IAP_ADFREE_MONTHLY] as const;

export type AppleIapPlan = 'coach' | 'adfree';

export function appleProductIdForPlan(plan: AppleIapPlan): string {
  return plan === 'adfree' ? APPLE_IAP_ADFREE_MONTHLY : APPLE_IAP_PRO_MONTHLY;
}

export function planForAppleProductId(productId: string): AppleIapPlan | null {
  if (productId === APPLE_IAP_PRO_MONTHLY) return 'coach';
  if (productId === APPLE_IAP_ADFREE_MONTHLY) return 'adfree';
  return null;
}
